import { fetchClueCofigData, subClueCofigData, fetchClueCofigFieldsData, setClueOpenClose } from '@/services/config'
import { getAuthTeamInfo } from '@/services/index'
const store = {
  namespaced: true,
  state: {
    // 获取配置默认数据
    datas: {},
    // 关联字段
    configFields: [],

    // 默认数据是否正在加载
    loadingContent: false,
    repeatSwitch: {},
    teamDatas: []
  },
  mutations: {
    setDatas (state, data) {
      state.datas = data
    },
    setConfigFields (state, data) {
      state.configFields = data
    },
    setLoadingContent (state, type) {
      state.loadingContent = type
    },
    setTeamDatas (state, data) {
      state.teamDatas = data
    }
  },
  getters: {
  },
  actions: {
    // 获取线索配置默认数据
    async fetchClueCofigData ({ commit }) {
      commit('setLoadingContent', true)
      const chain = await fetchClueCofigData()
        .onSuccess(raw => {
          commit('setDatas', raw)
        })
        .onNetComplete(() => {
          commit('setLoadingContent', false)
        })
        .config({ tip: false })
      return chain
    },
    // 获取配置关联字段
    async fetchClueCofigFieldsData ({ commit }) {
      // commit('setLoadingContent', true)
      const chain = await fetchClueCofigFieldsData()
        .onSuccess(raw => {
          commit('setConfigFields', Object.values(raw))
        })
        .onNetComplete(() => {
          // commit('setLoadingContent', false)
        })
        .config({ tip: false })
      return chain
    },
    // 获取团队小组人员
    async getAuthTeamInfo ({ commit }) {
      const chain = await getAuthTeamInfo()
        .params({ pk: 'clue-followup', deal: 1 })
        .onSuccess(raw => {
          commit('setTeamDatas', raw)
        })
        .onNetComplete(() => {
        })
        .config({ tip: false })
        .fetch()
      return chain
    },
    // 提交线索配置数据
    async subClueCofigData ({ commit, dispatch }) {
      const chain = await subClueCofigData()
        .onSuccess(async (raw) => {
          // const chain2 = await dispatch('fetchClueCofigData')
          // chain2.fetch()
        })
        .onNetComplete(() => {
        })
        .config({ tip: true })
      return chain
    },
    // 线索关闭或者开启
    async setClueOpenClose ({ commit, dispatch }, data) {
      const chain = await setClueOpenClose()
        .params(data)
        .onSuccess(async (raw) => {
          // const chain2 = await dispatch('fetchClueCofigData')
          // chain2.fetch()
        })
        .onNetComplete(() => {
        })
        .config({ tip: true })
      return chain
    }
  }
}

export default store
